import { render, staticRenderFns } from "./operation_teaching.vue?vue&type=template&id=162a704d&scoped=true"
import script from "./operation_teaching.vue?vue&type=script&lang=js"
export * from "./operation_teaching.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162a704d",
  null
  
)

export default component.exports